import { METRIC_DEFINITIONS } from '../constants';
import { MetricDefinition } from '../types';

const getMetricInfo = (metric: string = ''): MetricDefinition | undefined => (
    METRIC_DEFINITIONS[metric]
);

export default getMetricInfo;
